<template>
    <c-dialog ref="dialog"  mode="slide" mask-close width="800"  @resolve="editHandle">
        <c-form ref="form" vertical unit-width="100%">
            <c-input type="hidden" name="id"></c-input>

            <c-form-item label="费用分类" required>
                <c-select name="fee_category" :options="feeCategoryDic" disabled></c-select>
            </c-form-item>

            <c-form-item label="费用类型" required>
                <c-select name="fee_type" :options="feeTypeDic" :clear="false" disabled></c-select>
            </c-form-item>

            <c-form-item label="单价" required>
                <c-input name="unit_price" type="number" :decimal="2" :clear="false" placeholder="请输入单价"></c-input>
            </c-form-item>

            <c-form-item label="计算单位" required>
                <c-input name="calc_unit" maxlength="20" placeholder="如：元/天、元/公里"></c-input>
            </c-form-item>
            <c-form-item v-if="currentFeeType  == 4" label="其他规则" required >
                <c-form ref="holidayConfigForm" name="ladder_rules" link-parent column="2" style="margin-left: 15px;">
                    <c-form-item label="休息日倍数" >
                        <c-input v-model="ruleData.holiday_multiplier" name="holiday_multiplier" type="number" :precision="1" :clear="false" placeholder="如2表示双倍"></c-input>
                    </c-form-item>
                    <c-form-item label="法定节日倍数" >
                        <c-input v-model="ruleData.festival_multiplier" name="festival_multiplier" type="number" :precision="1" :clear="false" placeholder="如3表示三倍"></c-input>
                    </c-form-item>
                </c-form>
            </c-form-item>

            <c-form-item v-if="currentFeeType == 7" label="其他规则" required>
                <c-form ref="baseFeeConfigForm" name="ladder_rules" link-parent column="2" style="margin-left: 15px;">
                    <c-form-item label="基础费用(元)" >
                        <c-input v-model="ruleData.fee" name="fee" type="number" :precision="2" :clear="false" placeholder="N天以内的基础费用"></c-input>
                    </c-form-item>
                    <c-form-item label="最大天数(天)" >
                        <c-input v-model="ruleData.max_days" name="max_days" type="number" :precision="0" :clear="false" placeholder="基础费用覆盖的天数"></c-input>
                    </c-form-item>
                </c-form>
                <c-tips style="margin-top: 10px;">说明：{{ruleData.max_days || 3}}天以内固定收取{{ruleData.fee || 0}}元，超出天数按单价计算</c-tips>
            </c-form-item>
        </c-form>
    </c-dialog>
</template>

<script>
import { mapState } from 'vuex';
export default {
    data() {
        return {
            ruleData: null,
            currentFeeType:null
        }
    },

    computed:{
        ...mapState(['feeCategoryDic','feeTypeDic'])
    },

    methods: {
        /*********打开编辑框，初始化**********/
        open(data) {
            this.currentFeeType = data.fee_type;
            if (data.ladder_rules) {
                this.ruleData = JSON.parse(JSON.stringify(data.ladder_rules));
            }
            this.$refs.form.clear();
            if (data) {
                this.$refs.form.set(data);
            }
            //填充form表单
            this.$refs.dialog.open({
                title:'编辑费用配置'
            });
        },

        /*******创建、编辑提交处理方法********/
        editHandle (stop, next){
            stop();
            if(this.currentFeeType == 4 && (!this.ruleData.holiday_multiplier || !this.ruleData.festival_multiplier)){
                this.$message({
                    message: '请输入法定节日、休息日工资倍数',  // 提示内容,
                    type: 'warn'
                });
                return;
            }
            if(this.currentFeeType == 7 && (!this.ruleData.fee || !this.ruleData.max_days)){
                this.$message({
                    message: '请输入基础费用和最大天数',  // 提示内容,
                    type: 'warn'
                });
                return;
            }

            this.$refs.form.submit({
                url: '/aftersale/fee_config/update',
                rule: {
                    fee_category: '请选择费用分类',
                    fee_type: '请选择费用类型',
                    unit_price: '请输入单价',
                    calc_unit: '请输入计算单位',
                },
                dataFormatter: data => {
                    data.ladder_rules = null;
                    if(this.ruleData){
                        data.ladder_rules = JSON.stringify(this.ruleData);
                    }
                    return data;
                },
                success: (data, res) => {
                    next();
                    this.$message({
                        message: '提交成功',  // 提示内容,
                        type: 'success'
                    });
                    this.$emit('resolve');
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>